/* Lavelle home: progressive enhancement, no external dependencies. */
(() => {
  'use strict';
  const init = (root = document) => {
    const sections = root.matches?.('[data-lv-deals]') ? [root] : root.querySelectorAll('[data-lv-deals]');
    sections.forEach(section => {
      const filters = section.querySelector('[data-lv-filters]');
      if (!filters || filters.dataset.ready) return;
      const cards = [...section.querySelectorAll('[data-lv-category]')];
      if (!cards.length) return;
      filters.dataset.ready = 'true';
      filters.hidden = false;
      const buttons = [...filters.querySelectorAll('[data-lv-filter]')];
      buttons.forEach(button => {
        const value = button.dataset.lvFilter;
        if (value !== 'all' && !cards.some(card => card.dataset.lvCategory === value)) button.hidden = true;
      });
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-lv-filter]');
        if (!button || !filters.contains(button)) return;
        const value = button.dataset.lvFilter;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        cards.forEach(card => {
          card.hidden = value !== 'all' && card.dataset.lvCategory !== value;
          if (!card.hidden) visible += 1;
        });
        const status = section.querySelector('[data-lv-filter-status]');
        if (status) status.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} shown. ${button.textContent.trim()}.`;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
